// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ✅ Fixed Navbar */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background-color: white;
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sort{
  /* height: 13px; */
  /* width: 13px; */
}

/* ✅ Main Layout */
.contain {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.table-containerAdd {
  /* margin: 70px 70px; */
  /* margin-top: 200px; */
  margin-right: 50px;
}

.search-containerAdd {
  margin-right: 20px;
}

.search-containerAdd input[type='text'] {
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  color: black;
  outline: none;
}

.search-containerAdd input[type='text']:hover,
.search-containerAdd input[type='text']:focus {
  border: 2px solid #2865aa;
  font-size: 16px;
}

.update {
  background-color: #2865aa;
}

/* ✅ Mobile Scroll Table - Default Hidden */
.mobile-scroll-table-add {
  display: none;
  overflow-x: auto;
  margin-top: 20px;
  width: 100%;
}

/* ✅ Table Base Styling */
.mobile-scroll-table-add table {
  border-collapse: collapse;
  min-width: max-content;
}

.mobile-scroll-table-add td,
.mobile-scroll-table-add th {
  /* padding: 8px 12px; */
  border: 1px solid #ccc;
  text-align: center;
  vertical-align: middle;

  /* ✅ Email wrapping support */
  white-space: normal;
  word-break: break-word;
  /* min-width: 180px; */
}

/* ✅ Wider Email Column */
.mobile-scroll-table-add td:nth-child(6),
.mobile-scroll-table-add th:nth-child(6) {
  min-width: 100px;
}

/* ✅ Sticky First Column */
.mobile-scroll-table-add td:first-child,
.mobile-scroll-table-add th:first-child {
  position: sticky;
  left: 0;
  background-color: #f9f9f9;
  z-index: 2;
  text-align: center;
  vertical-align: middle;
}

/* ✅ Sticky Header Row */
.mobile-scroll-table-add thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 3;
  text-align: center;
  vertical-align: middle;
}

/* ✅ Responsive for Mobile */
@media (max-width: 768px) {
  .table-containerAdd {
    margin: 5px;
    /* margin-top: 40px; */
  }

  .desktop-tableAdd {
    display: none;
  }

  .mobile-scroll-table-add {
    display: block;
    overflow-x: auto;
    margin: 0;
    text-align: center;
    margin-top: 20px;
    font-size: 10px;
  }

  .mobile-scroll-table-add table {
    width: max-content;
    border-collapse: collapse;
    margin: auto;
  }

  .mobile-scroll-table-add td,
  .mobile-scroll-table-add th {
    /* padding: 8px 10px; */
    border: 1px solid #ddd;
    text-align: center;
    vertical-align: middle;
    white-space: normal;
    word-break: break-word;
    min-width: 70px;
  }

  .sticky-col{
    /* display: block; */
    /* overflow-x: auto; */
    /* margin: 0; */
    text-align: center;
    /* margin-top: 20px; */
    font-size: 10px;
  }

  .search-containerAdd input[type='text'] {
    padding: 10px;
    font-size: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
    color: black;
    outline: none;
  }
  
  .search-containerAdd input[type='text']:hover,
  .search-containerAdd input[type='text']:focus {
    border: 1px solid #2865aa;
    font-size: 10px;
  }

  .mobile-scroll-table-add td:nth-child(6),
  .mobile-scroll-table-add th:nth-child(6) {
    min-width: 100px;
  }

  .mobile-scroll-table-add td:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
    background: #f2f2f2;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    border-left: 1px solid #ddd !important;
    box-shadow: inset 1px 0 0 #ddd;
  }

  .update {
    background-color: #2865aa;
  }

  .sort-iconm {
    margin-left: 4px;
    /* height: 11px; */
    /* width: 11px; */
    /* vertical-align: middle; */
  }
}

`, "",{"version":3,"sources":["webpack://./src/createadmin.css"],"names":[],"mappings":";AACA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;;EAEtB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;;EAEE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;;EAEE,gBAAgB;EAChB,OAAO;EACP,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;EACd;;EAEA;;IAEE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,sCAAsC;IACtC,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;EAC9B;AACF","sourcesContent":["\n/* ✅ Fixed Navbar */\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 70px;\n  background-color: white;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.sort{\n  /* height: 13px; */\n  /* width: 13px; */\n}\n\n/* ✅ Main Layout */\n.contain {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.main-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.table-containerAdd {\n  /* margin: 70px 70px; */\n  /* margin-top: 200px; */\n  margin-right: 50px;\n}\n\n.search-containerAdd {\n  margin-right: 20px;\n}\n\n.search-containerAdd input[type='text'] {\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  color: black;\n  outline: none;\n}\n\n.search-containerAdd input[type='text']:hover,\n.search-containerAdd input[type='text']:focus {\n  border: 2px solid #2865aa;\n  font-size: 16px;\n}\n\n.update {\n  background-color: #2865aa;\n}\n\n/* ✅ Mobile Scroll Table - Default Hidden */\n.mobile-scroll-table-add {\n  display: none;\n  overflow-x: auto;\n  margin-top: 20px;\n  width: 100%;\n}\n\n/* ✅ Table Base Styling */\n.mobile-scroll-table-add table {\n  border-collapse: collapse;\n  min-width: max-content;\n}\n\n.mobile-scroll-table-add td,\n.mobile-scroll-table-add th {\n  /* padding: 8px 12px; */\n  border: 1px solid #ccc;\n  text-align: center;\n  vertical-align: middle;\n\n  /* ✅ Email wrapping support */\n  white-space: normal;\n  word-break: break-word;\n  /* min-width: 180px; */\n}\n\n/* ✅ Wider Email Column */\n.mobile-scroll-table-add td:nth-child(6),\n.mobile-scroll-table-add th:nth-child(6) {\n  min-width: 100px;\n}\n\n/* ✅ Sticky First Column */\n.mobile-scroll-table-add td:first-child,\n.mobile-scroll-table-add th:first-child {\n  position: sticky;\n  left: 0;\n  background-color: #f9f9f9;\n  z-index: 2;\n  text-align: center;\n  vertical-align: middle;\n}\n\n/* ✅ Sticky Header Row */\n.mobile-scroll-table-add thead th {\n  position: sticky;\n  top: 0;\n  background-color: #fff;\n  z-index: 3;\n  text-align: center;\n  vertical-align: middle;\n}\n\n/* ✅ Responsive for Mobile */\n@media (max-width: 768px) {\n  .table-containerAdd {\n    margin: 5px;\n    /* margin-top: 40px; */\n  }\n\n  .desktop-tableAdd {\n    display: none;\n  }\n\n  .mobile-scroll-table-add {\n    display: block;\n    overflow-x: auto;\n    margin: 0;\n    text-align: center;\n    margin-top: 20px;\n    font-size: 10px;\n  }\n\n  .mobile-scroll-table-add table {\n    width: max-content;\n    border-collapse: collapse;\n    margin: auto;\n  }\n\n  .mobile-scroll-table-add td,\n  .mobile-scroll-table-add th {\n    /* padding: 8px 10px; */\n    border: 1px solid #ddd;\n    text-align: center;\n    vertical-align: middle;\n    white-space: normal;\n    word-break: break-word;\n    min-width: 70px;\n  }\n\n  .sticky-col{\n    /* display: block; */\n    /* overflow-x: auto; */\n    /* margin: 0; */\n    text-align: center;\n    /* margin-top: 20px; */\n    font-size: 10px;\n  }\n\n  .search-containerAdd input[type='text'] {\n    padding: 10px;\n    font-size: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: 100%;\n    color: black;\n    outline: none;\n  }\n  \n  .search-containerAdd input[type='text']:hover,\n  .search-containerAdd input[type='text']:focus {\n    border: 1px solid #2865aa;\n    font-size: 10px;\n  }\n\n  .mobile-scroll-table-add td:nth-child(6),\n  .mobile-scroll-table-add th:nth-child(6) {\n    min-width: 100px;\n  }\n\n  .mobile-scroll-table-add td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n    background: #f2f2f2;\n    font-weight: 600;\n    text-align: center;\n    vertical-align: middle;\n    border-left: 1px solid #ddd !important;\n    box-shadow: inset 1px 0 0 #ddd;\n  }\n\n  .update {\n    background-color: #2865aa;\n  }\n\n  .sort-iconm {\n    margin-left: 4px;\n    /* height: 11px; */\n    /* width: 11px; */\n    /* vertical-align: middle; */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
